import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { history } from './Utils/utils';
import { reducer as auth, AuthTypes } from './Containers/LoginPage/reducer';
import { reducer as startup } from './Redux/StartupRedux';
import { reducer as nav } from './Redux/NavRedux';
import { reducer as errors } from './Redux/ErrorsRedux';

import { reducer as user } from './Containers/User/reducer';
import { reducer as dashboard } from './Containers/DashboardPage/reducer';
import { reducer as report } from './Containers/ReportPage/reducer';
import { reducer as monthlyReport } from './Containers/MonthlyReportPage/reducer';
import { reducer as monthlyScoreReport } from './Containers/MonthlyScoreReportPage/reducer';
import { reducer as balancerMetrics } from './Containers/BalancerMetricsPage/reducer';

const appReducer = combineReducers({
  auth,
  nav,
  errors,
  startup,
  user,
  dashboard,
  report,
  monthlyReport,
  monthlyScoreReport,
  balancerMetrics,
  router: connectRouter(history),
});

// On sign-out reset every slice to its initial state, so dashboard data (events,
// IPs, emails) does not stay in memory or in persisted localStorage. Only `router`
// and `startup` keep their values. `nav` is passed through too, but NavRedux
// resets itself on LOGOUT_SUCCESS anyway. `startup` must survive: the startup saga
// runs once per page load, and InitComponent shows a full-screen spinner while
// startup.success is false.
export const reducers = (state, action) => {
  if (action.type === AuthTypes.LOGOUT_SUCCESS && state) {
    return appReducer(
      { router: state.router, nav: state.nav, startup: state.startup },
      action,
    );
  }
  return appReducer(state, action);
};

export default reducers;
